import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationStatusCode } from '../models/application-general.model';

@Pipe({
  standalone: false,
  name: 'applicationGlobalStatus'
})
export class ApplicationGlobalStatusPipe implements PipeTransform {

  private types: { [key: string]: string } = {};

  constructor() {
    this.types[ApplicationStatusCode.new] = 'New';
    this.types[ApplicationStatusCode.inProgress] = 'In Progress';
    this.types[ApplicationStatusCode.pendingPaymentPlanApproval] = 'Pending Payment Plan Approval';
    this.types[ApplicationStatusCode.pendingManagerApproval] = 'Pending Manager Approval';
    this.types[ApplicationStatusCode.screening] = 'Screening';
    this.types[ApplicationStatusCode.pendingScreeningManualApproval] = 'Pending Screening Manual Approval';
    this.types[ApplicationStatusCode.completed] = 'Completed';
    this.types[ApplicationStatusCode.approved] = 'Approved';
    this.types[ApplicationStatusCode.rejected] = 'Rejected';
    this.types[ApplicationStatusCode.error] = 'Error';
    this.types[ApplicationStatusCode.canceled] = 'Canceled';
    this.types[ApplicationStatusCode.archived] = 'Archived';
    this.types[ApplicationStatusCode.reopened] = 'Reopened';
  }

  transform(value: ApplicationStatusCode | undefined): string {
    if (value === null || value === undefined) {
      return 'N/A';
    }
    return this.types[value] ?? 'Unknown';
  }
}
